import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { Notification_Types } from "../constants/notificationTypes";

export const getReport = (actionUrl, type) => {
  //TODO : this is temp functionality for uat
  // need to revisit the notification functionality
  let url = actionUrl.split("/");
  let id = url[1];
  let fileName = url[2];

  return base.exportFile({
    method: "get",
    url: type === Notification_Types.ERROR ? API_PARAM.EXPORT_ERRORS : API_PARAM.EXPORT,
    params: { id },
    fileName: fileName,
  });
};
